import PropTypes from 'prop-types';
import DoughnutChart from '@/components/charts/DoughnutChart';

const DoughnutSummaryItem = ({ name, label, data, labels, maxScope }) => {
  return (
    <div className="flex gap-4">
      <div className="max-w-32">
        <DoughnutChart data={{ data, labels, maxScope }} showCenterLabel={true} />
      </div>
      <div className="flex flex-col gap-1 self-center">
        <div className="font-bold text-sm">{name}</div>
        <div className="text-sm">{label}</div>
      </div>
    </div>
  );
};

DoughnutSummaryItem.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  data: PropTypes.array,
  labels: PropTypes.array,
  maxScope: PropTypes.object,
};

export default DoughnutSummaryItem;
